import { tv } from "@fanka/tailwind-variants";

export const CALENDAR_CELL_CLASS_NAME = tv({
  base: "flex border-r border-grayScale-200 bg-base-0 border-collapse hover:bg-base-300 active:bg-base-400",
  variants: {
    isDivider: {
      true: "border-t-[3px]",
      false: "border-t-[1px]",
    },
    isStart: {
      true: "border-t-0",
    },
  },
  defaultVariants: {
    isDivider: false,
    isStart: false,
  },
});
